import React from "react";
import { NavLink } from "react-router-dom";

var img1 = require("./../../images/background/ptn-1.png");

const projectStats = [
  {
    number: "5",
    unit: "Lakh Tons",
    label: "Supply Capacity",
    icon: "fa fa-industry",
    color: "#007bff",
  },
  {
    number: "100+",
    unit: "Crore/Year",
    label: "GMV",
    icon: "fa fa-inr",
    color: "#28a745",
  },
  {
    number: "15-20",
    unit: "Daily",
    label: "Deliveries",
    icon: "fa fa-truck",
    color: "#dc3545",
  },
  {
    number: "75%",
    unit: "Repeat Purchases",
    label: "Customer Loyalty",
    icon: "fa fa-refresh",
    color: "#ffc107",
  },
];

const projectTypes = [
  {
    title: "Hospital",
    icon: "fa fa-hospital-o",
    image: require("./../../images/project/hospital.jpeg"),
    description:
      "Medical infrastructure requiring specialized building materials for safety and durability.",
    color: "#e74c3c",
  },
  {
    title: "Hotel",
    icon: "fa fa-bed",
    image: require("./../../images/project/hotel.jpeg"),
    description:
      "Hospitality projects with focus on aesthetic appeal and long-lasting construction.",
    color: "#f39c12",
  },
  {
    title: "School",
    icon: "fa fa-graduation-cap",
    image: require("./../../images/project/school.jpeg"),
    description:
      "Educational facilities designed for safety, functionality and conducive learning environment.",
    color: "#3498db",
  },
  {
    title: "Bridge",
    icon: "fa fa-road",
    image: require("./../../images/project/brige.jpeg"),
    description:
      "Infrastructure projects requiring high-strength materials for structural integrity.",
    color: "#9b59b6",
  },
  {
    title: "Metro / Railway Station",
    icon: "fa fa-train",
    image: require("./../../images/project/Metro.jpg"),
    description:
      "Transportation hubs built with premium materials for heavy-duty performance.",
    color: "#1abc9c",
  },
  {
    title: "Highway's",
    icon: "fa fa-road",
    image: require("./../../images/project/Highway.jpg"),
    description:
      "Road infrastructure projects ensuring smooth and durable transportation networks.",
    color: "#34495e",
  },
  {
    title: "Commercial Buildings",
    icon: "fa fa-building-o",
    image: require("./../../images/project/Commercial.webp"),
    description:
      "Business complexes and office buildings with modern construction solutions.",
    color: "#e67e22",
  },
  {
    title: "Residential Building",
    icon: "fa fa-home",
    image: require("./../../images/project/house.png"),
    description:
      "Housing projects focused on quality living spaces and sustainable construction.",
    color: "#27ae60",
  },
];

class ProjectsSection extends React.Component {
  render() {
    return (
      <>
        {/* STATISTICS SECTION */}
        <div
          className="section-full p-tb80 bg-white bg-repeat inner-page-padding"
          style={{ backgroundImage: "url(" + img1 + ")" }}
        >
          <div className="container">
            <div className="section-head text-center">
              <div className="mt-separator-outer separator-center">
                <div className="mt-separator">
                  <h2 className="text-uppercase sep-line-one">
                    <span className="font-weight-300 text-primary">Our</span>{" "}
                    Achievements
                  </h2>
                </div>
                <p className="lead">
                  Delivering excellence in building material supply across
                  diverse infrastructure projects
                </p>
              </div>
            </div>

            <div className="section-content m-b50">
              <div className="row">
                {projectStats.map((stat, index) => (
                  <div key={index} className="col-lg-3 col-md-4 col-sm-6 m-b30">
                    <div
                      className="stats-card text-center"
                      style={{
                        backgroundColor: "#fff",
                        borderRadius: "20px",
                        padding: "40px 30px",
                        boxShadow: "0 15px 35px rgba(0,0,0,0.1)",
                        border: "1px solid #f0f0f0",
                        transition: "all 0.3s ease",
                        height: "100%",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        className="stats-icon m-b20"
                        style={{
                          backgroundColor: stat.color,
                          color: "white",
                          width: "80px",
                          height: "80px",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto",
                          boxShadow: `0 8px 25px ${stat.color}30`,
                        }}
                      >
                        <i
                          className={stat.icon}
                          style={{ fontSize: "32px" }}
                        ></i>
                      </div>
                      <div
                        className="stats-number"
                        style={{
                          fontSize: "48px",
                          fontWeight: "bold",
                          color: stat.color,
                          lineHeight: "1",
                          marginBottom: "8px",
                        }}
                      >
                        {stat.number}
                      </div>
                      <div
                        className="stats-unit"
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#6c757d",
                          marginBottom: "10px",
                        }}
                      >
                        {stat.unit}
                      </div>
                      <div
                        className="stats-label"
                        style={{
                          fontSize: "14px",
                          color: "#495057",
                          fontWeight: "500",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        {stat.label}
                      </div>

                      {/* Background decoration */}
                      <div
                        style={{
                          position: "absolute",
                          top: "-20px",
                          right: "-20px",
                          width: "100px",
                          height: "100px",
                          backgroundColor: `${stat.color}10`,
                          borderRadius: "50%",
                          zIndex: "0",
                        }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* PROJECT TYPES SECTION */}
        <div className="section-full p-tb80 bg-gray bg-repeat inner-page-padding">
          <div className="container">
            <div className="section-head text-center m-b50">
              <div className="mt-separator-outer separator-center">
                <div className="mt-separator">
                  <h2 className="text-uppercase sep-line-one">
                    <span className="font-weight-300 text-primary">
                      Supply to
                    </span>{" "}
                    Projects
                  </h2>
                </div>
                <p className="lead">
                  Comprehensive building material solutions for diverse
                  infrastructure and construction projects
                </p>
              </div>
            </div>

            <div className="section-content">
              <div className="row">
                {projectTypes.map((project, index) => (
                  <div key={index} className="col-lg-3 col-md-6 col-sm-6 m-b30">
                    <div
                      className="project-card"
                      style={{
                        backgroundColor: "#fff",
                        borderRadius: "15px",
                        overflow: "hidden",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                        border: "1px solid #e9ecef",
                        transition: "all 0.3s ease",
                        height: "100%",
                      }}
                    >
                      <div
                        className="project-image"
                        style={{
                          position: "relative",
                          overflow: "hidden",
                          height: "200px",
                        }}
                      >
                        <img
                          src={project.image}
                          alt={project.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            transition: "transform 0.3s ease",
                          }}
                        />
                        <div
                          className="project-overlay"
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            right: "0",
                            bottom: "0",
                            background: `linear-gradient(135deg, ${project.color}90, ${project.color}60)`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            opacity: "0",
                            transition: "opacity 0.3s ease",
                          }}
                        >
                          <i
                            className={project.icon}
                            style={{
                              fontSize: "48px",
                              color: "white",
                            }}
                          ></i>
                        </div>
                      </div>

                      <div
                        className="project-content"
                        style={{ padding: "25px 20px" }}
                      >
                        <div
                          className="project-icon m-b15"
                          style={{
                            backgroundColor: project.color,
                            color: "white",
                            width: "50px",
                            height: "50px",
                            borderRadius: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: `0 4px 15px ${project.color}30`,
                          }}
                        >
                          <i
                            className={project.icon}
                            style={{ fontSize: "20px" }}
                          ></i>
                        </div>

                        <h4
                          style={{
                            color: "#2c3e50",
                            fontSize: "18px",
                            fontWeight: "600",
                            marginBottom: "12px",
                            lineHeight: "1.3",
                          }}
                        >
                          {project.title}
                        </h4>

                        <p
                          style={{
                            color: "#6c757d",
                            fontSize: "14px",
                            lineHeight: "1.5",
                            marginBottom: "20px",
                          }}
                        >
                          {project.description}
                        </p>

                        <div className="project-features">
                          <div
                            className="feature-badge"
                            style={{
                              backgroundColor: `${project.color}15`,
                              color: project.color,
                              padding: "4px 12px",
                              borderRadius: "15px",
                              fontSize: "12px",
                              fontWeight: "600",
                              display: "inline-block",
                            }}
                          >
                            Specialized Materials
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Call to Action */}
            <div className="section-content text-center m-t50">
              <div
                className="cta-section"
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "50px 40px",
                  boxShadow: "0 15px 35px rgba(0,0,0,0.1)",
                  border: "1px solid #e9ecef",
                }}
              >
                <h3
                  style={{
                    color: "#2c3e50",
                    fontSize: "32px",
                    fontWeight: "600",
                    marginBottom: "15px",
                  }}
                >
                  Ready to Start Your Project?
                </h3>
                <p
                  style={{
                    color: "#6c757d",
                    fontSize: "18px",
                    marginBottom: "30px",
                    maxWidth: "600px",
                    margin: "0 auto 30px auto",
                  }}
                >
                  Get premium building materials delivered to your project site
                  with our reliable supply chain and expert support team.
                </p>
                <NavLink
                  to="/contactus"
                  className="site-button btn-effect"
                  style={{
                    backgroundColor: "#007bff",
                    color: "white",
                    padding: "15px 40px",
                    fontSize: "16px",
                    fontWeight: "600",
                    textTransform: "uppercase",
                    letterSpacing: "1px",
                    borderRadius: "30px",
                    textDecoration: "none",
                    display: "inline-block",
                    transition: "all 0.3s ease",
                    boxShadow: "0 8px 25px rgba(0,123,255,0.3)",
                  }}
                >
                  <span>Get Quote Now</span>
                </NavLink>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
                    .project-card:hover .project-image img {
                        transform: scale(1.1);
                    }
                    
                    .project-card:hover .project-overlay {
                        opacity: 1;
                    }
                    
                    .stats-card:hover {
                        transform: translateY(-10px);
                        box-shadow: 0 25px 45px rgba(0,0,0,0.15);
                    }
                    
                    .project-card:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 15px 35px rgba(0,0,0,0.15);
                    }
                `}</style>
      </>
    );
  }
}

export default ProjectsSection;
